import { render, staticRenderFns } from "./HideResponsavelNotasPersistView.vue?vue&type=template&id=59e4da2e"
import script from "./HideResponsavelNotasPersistView.vue?vue&type=script&lang=ts"
export * from "./HideResponsavelNotasPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports